var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"div",class:_vm.type,attrs:{"prefix":_vm.prefix,"content":_vm.content,"image-src":_vm.imageSrc,"image-alt":_vm.imageAlt,"modal":_vm.modal,"arrow-left":_vm.arrowLeft,"complete":_vm.complete,"incorrect":_vm.incorrect}})}
var staticRenderFns = []

export { render, staticRenderFns }